var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found body-card-border-primary"},[_c('h1',[_vm._v("404 - Página No Encontrada")]),_c('p',[_vm._v("Lo sentimos, pero la página que buscas no existe.")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Volver")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }